// extracted by mini-css-extract-plugin
module.exports = {"noData":"NoData_noData__ee_X5","fixedDarkTheme":"NoData_fixedDarkTheme__7Fhx7","imgBox":"NoData_imgBox__DqzxF","text-center":"NoData_text-center__6sphW"};